import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@eliadmin/core/src/components/ui/select';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useRealtyStore } from '../../../stores/realty-store';
import type { RealtyOrder, RealtyOrderBy } from '../../../utils/realty-filter-contract';
import { RealtyFilterChevron } from './realty-filter-chevron';
import styles from './realty-sort.module.css';

export const RealtyFilterSortDesktop = () => {
  const { t } = useTranslations();
  const { SORT_VALUES, applySort, filter } = useRealtyStore();

  return (
    <div className={styles.desktopRoot} data-eli-part="listing-desktop-sort">
      <p className={styles.desktopLabel}>{t('text1421')}</p>
      <Select
        value={`${filter.orderBy}:${filter.order}`}
        onValueChange={value => {
          const [orderBy, order] = value.split(':') as [RealtyOrderBy, RealtyOrder];
          applySort(orderBy, order);
        }}
      >
        <SelectTrigger
          value={`${filter.orderBy}:${filter.order}`}
          className={styles.desktopSelectTrigger}
          innerTriggerClassName={styles.desktopSelectTriggerInner}
          aria-label={t('text1421')}
          expandIcon={
            <RealtyFilterChevron
              className={styles.desktopChevron}
              data-eli-part="listing-sort-chevron"
            />
          }
        >
          <SelectValue placeholder="" />
        </SelectTrigger>
        <SelectContent className={styles.selectContent}>
          {SORT_VALUES.map(value => (
            <SelectItem key={value.value} value={value.value} className={styles.selectItem}>
              {t(`${value.label}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
